import { useAppUiI18n } from '@/i18n/AppUiI18nProvider'
import { APP_UI_LOCALE_OPTIONS } from '@/i18n/appUiLocale'
import { useTranslation } from '@/i18n/useTranslation'

type AppLanguageSwitcherProps = {
  className?: string
  /** Compact: icon-free select only */
  variant?: 'default' | 'compact'
  /** Show the Language label on all screen sizes (e.g. auth pages). */
  showLabel?: boolean
}

export function AppLanguageSwitcher({
  className = '',
  variant = 'default',
  showLabel = false,
}: AppLanguageSwitcherProps) {
  const { locale, setLocale } = useAppUiI18n()
  const { t } = useTranslation('common')

  return (
    <label
      className={`inline-flex items-center gap-2 text-sm text-gray-600 ${className}`}
      title={t('language')}
    >
      {variant === 'default' || showLabel ? (
        <span
          className={
            showLabel
              ? 'font-medium text-gray-500'
              : 'hidden lg:inline font-medium text-gray-500'
          }
        >
          {t('language')}
        </span>
      ) : null}
      <select
        value={locale}
        onChange={(e) => setLocale(e.target.value as typeof locale)}
        className="rounded-md border border-gray-300 bg-white py-1 pl-2 pr-7 text-sm text-gray-900 focus:border-primary-500 focus:outline-none focus:ring-1 focus:ring-primary-500"
        aria-label={t('language')}
      >
        {APP_UI_LOCALE_OPTIONS.map((opt) => (
          <option key={opt.value} value={opt.value}>
            {opt.label}
          </option>
        ))}
      </select>
    </label>
  )
}
